import { DocumentBuilderRoute } from '/@/modules/documentbuilder/routes/documentbuilder.routes';
import { DocumentBuilderRouteConfig } from '/@/modules/documentbuilder/routes/DocumentBuilderRouteConfig';

export const router = [
  DocumentBuilderRouteConfig.factory({
    path: `/${DocumentBuilderRoute.DOCUMENTBUILDER.path}`,
    name: DocumentBuilderRoute.DOCUMENTBUILDER.name,
    component: () => import('/@/modules/documentbuilder/pages/DocumentBuilderPage.vue'),
    meta: { authOnly: true }
  }).build()
];
